export const MAX_IMAGE_COUNT = 3;
export const MAX_ORIGINAL_IMAGE_BYTES = 20 * 1024 * 1024;

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("图片压缩失败")), type, quality);
  });
}

export async function compressImage(file) {
  if (!(file instanceof Blob) || !String(file.type || "").startsWith("image/")) throw new Error("请选择图片文件");
  if (file.size > MAX_ORIGINAL_IMAGE_BYTES) throw new Error(`“${file.name || "这张图片"}”超过 20 MB，请选择更小的图片。`);
  let bitmap;
  try { bitmap = await createImageBitmap(file); }
  catch (_) { return { blob: file, name: file.name || "生活图片", mimeType: file.type || "image/jpeg", width: null, height: null, originalBytes: file.size }; }
  const scale = Math.min(1, 2048 / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = width; canvas.height = height;
  const context = canvas.getContext("2d", { alpha: false });
  context.fillStyle = "#fffdf8"; context.fillRect(0, 0, width, height); context.drawImage(bitmap, 0, 0, width, height); bitmap.close();
  let quality = 0.84;
  let blob = await canvasToBlob(canvas, "image/jpeg", quality);
  while (blob.size > 2.5 * 1024 * 1024 && quality > 0.58) { quality -= 0.08; blob = await canvasToBlob(canvas, "image/jpeg", quality); }
  return { blob, name: `${String(file.name || "生活图片").replace(/\.[^.]+$/, "")}.jpg`, mimeType: "image/jpeg", width, height, originalBytes: file.size };
}
